export default __webpack_public_path__ + "media/faq/faq_awards_screenshot_1-ccce07ee.png";